import React, {useEffect} from 'react';
import { PDFDocument } from 'pdf-lib';
// import fontkit from '@pdf-lib/fontkit';
import pdfCompleto from '../assets/pdf/pdf-completo.pdf';

const Pdf = () => {

  useEffect(() => {
    readPdf()
  }, []);

  const readPdf = async () => {
    const fromBytes = await fetch(pdfCompleto).then((res) => res.arrayBuffer());

    // Load the PDF with form fields
    const pdfDoc = await PDFDocument.load(fromBytes);

    const form = pdfDoc.getForm();
    const field1 = form.getTextField('Text1');
    const field2 = form.getTextField('Text2');
  }

  return (
    <div>
      <h1>PDF</h1>
    </div>
  );
};

export default Pdf;
